export enum DatakatalogMode {
    SMALL = 'small',
    BIG = 'big',
    FLOATING_WINDOW = 'floatingWindow',
}

export const DATAKATALOG_STATISTICS_INFO =
    'Merk: statistikk over vegobjekter som vises i datakatalogen tar ikke hensyn til avgrensninger gjort i Vegkart.';
